import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { RequestInterceptor } from "./request.interceptor";
import { SnapshotInterceptor } from "./snapshot.interceptor";

@NgModule({
    declarations: [],
    imports: [],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SnapshotInterceptor,
            multi: true
        }
    ]
})
export class InterceptorModule { }
